export const Drip = ({ color = "#C8102E", flip = false }) => (
  <div
    aria-hidden="true"
    className="w-full overflow-hidden leading-[0]"
    style={{ transform: flip ? "scaleY(-1)" : "none" }}
  >
    <svg viewBox="0 0 1200 60" preserveAspectRatio="none" className="w-full h-[28px] md:h-[40px] block">
      <path
        fill={color}
        d="M0,0 L1200,0 L1200,18 C1180,18 1175,52 1155,52 C1135,52 1130,18 1110,18 C1090,18 1085,40 1065,40 C1045,40 1040,18 1020,18 C1000,18 992,58 968,58 C944,58 940,18 916,18 C892,18 888,46 864,46 C840,46 836,18 812,18 C788,18 782,52 760,52 C738,52 734,18 712,18 C690,18 684,42 662,42 C640,42 636,18 612,18 C588,18 582,56 558,56 C534,56 530,18 506,18 C482,18 478,44 454,44 C430,44 426,18 402,18 C378,18 372,52 350,52 C328,52 324,18 302,18 C280,18 274,40 252,40 C230,40 226,18 202,18 C178,18 172,54 148,54 C124,54 120,18 96,18 C72,18 66,44 44,44 C22,44 18,18 0,18 Z"
      />
    </svg>
  </div>
);
